import { render } from "./WideWidget.vue?vue&type=template&id=59f39664&scoped=true"
import script from "./WideWidget.vue?vue&type=script&lang=js"
export * from "./WideWidget.vue?vue&type=script&lang=js"

import "./wide-widget.scss?vue&type=style&index=0&id=59f39664&lang=scss&scoped=true"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59f39664"]])

export default __exports__